<template>
    <div class="flex flex-col mt-4 ml-64 sm:ml-80 align-center h-32">
        <p class="basis-1/6 -ml-28 sm:-ml-12 lg:-ml-2 text-sm font-light tracking-widest">samuel knowlton is </p>
        <p class="basis-3/6 -mt-8 -ml-60 sm:-ml-56 lg:-ml-48 lg:whitespace-nowrap font-script text-8xl sm:text-9xl subpixel-antialiased"> Discount Darcy</p>
        <p class="basis-1/6 mt-4 lg:mt-0 -ml-56 sm:-ml-72 lg:-ml-20 tracking-wider font-medium xs:text-nowrap xs:whitespace-nowrap">voiceover &amp; performance . semblance of authority</p>
        <img class="basis-1/6 h-16 w-16 mt-4 -ml-32 xs2:-ml-12 sm:-ml-20 lg:ml-20 3xl:ml-48" src="../assets/images/svg/fleur-de-lis-small.svg" />        
    </div>
</template>